import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { REGISTER } from "@/constants/testIds";

export default function Register() {
  const { setSession } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      setSession(data);
      toast.success("¡Bienvenido a Apúntate!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream-50">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl text-ink-900 font-light">Crear cuenta</h1>
        <p className="mt-3 text-ink-500">En un minuto tienes tu primera hoja lista.</p>

        <form onSubmit={submit} className="mt-10 space-y-6" data-testid="register-form">
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-[0.2em] text-ink-500">Nombre</Label>
            <Input
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Tu nombre"
              className="rounded-xl border-line h-12"
              data-testid={REGISTER.nameInput}
            />
          </div>
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-[0.2em] text-ink-500">Correo</Label>
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@correo.com"
              className="rounded-xl border-line h-12"
              data-testid={REGISTER.emailInput}
            />
          </div>
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-[0.2em] text-ink-500">Contraseña</Label>
            <Input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mínimo 6 caracteres"
              className="rounded-xl border-line h-12"
              data-testid={REGISTER.passwordInput}
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-full bg-coral hover:bg-coral-hover text-white"
            data-testid={REGISTER.submitButton}
          >
            {loading ? "Creando…" : "Crear cuenta"}
          </Button>
        </form>

        <p className="mt-8 text-sm text-ink-500 text-center">
          ¿Ya tienes cuenta?{" "}
          <Link to="/login" className="text-coral hover:underline" data-testid={REGISTER.loginLink}>
            Inicia sesión
          </Link>
        </p>
      </div>
    </div>
  );
}
